import { render } from "./account.vue?vue&type=template&id=02ff8632&scoped=true"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"

import "./account.vue?vue&type=style&index=0&id=02ff8632&scoped=true&lang=scss"

import exportComponent from "F:\\webWork\\demo\\h5sdk2\\h5sdk3.muugame.com\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02ff8632"]])

export default __exports__